window.globalHelpersModule.directive "personalInfo", 
['$rootScope', '$log', '$timeout', '$state', ($rootScope, $log, $timeout, $state) ->
  restrict: "E"
  scope:
    phrPatient: '='
  link: (scope, element, attrs) ->

  templateUrl: 'portal/profile/personal-info-directive-template.html'
]